import { render, staticRenderFns } from "./CorporateSetting.vue?vue&type=template&id=840fa53c"
import script from "./CorporateSetting.vue?vue&type=script&lang=js"
export * from "./CorporateSetting.vue?vue&type=script&lang=js"
import style0 from "./CorporateSetting.vue?vue&type=style&index=0&id=840fa53c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports